import {
  CreateUpdateContractEstimateItemDtoFromJSON,
  CreateUpdateContractEstimateItemsDto,
  DefaultApi,
  GetContractEstimateItemDto,
  GetLastEditorDto,
} from '../autogenerated/pokApiClient';

export interface ContractEstimateItemContextInterface {
  getLastEstimateItemEditor: (id: string) => Promise<GetLastEditorDto>;
  updateEstimateItems: (
    id: string,
    dto: CreateUpdateContractEstimateItemsDto,
  ) => Promise<void>;
}

export const ContractEstimateItemContext = (api: DefaultApi) => {
  return {
    getLastEstimateItemEditor: (id: string) =>
      api.contractEstimateItemsControllerGetLastEstimateItemEditor(id),
    updateEstimateItems: (
      id: string,
      dto: CreateUpdateContractEstimateItemsDto,
    ) =>
      api.contractEstimateItemsControllerUpdateContractEstimateItems(id, dto),
  };
};

export const newContractEstimateItem = () => {
  return CreateUpdateContractEstimateItemDtoFromJSON({});
};

export const convert = (contractEstimateItem?: GetContractEstimateItemDto) => {
  if (!contractEstimateItem) {
    return newContractEstimateItem();
  }
  const converted =
    CreateUpdateContractEstimateItemDtoFromJSON(contractEstimateItem);
  converted.estimateItemId = contractEstimateItem?.estimateItem?.id;
  converted.contractId = contractEstimateItem?.contract?.id;
  return converted;
};
